module.exports = function(){
    require('jquery-placeholder');
    $('input, textarea').placeholder();
}();